<script>
  import { cart, stage, Stages, loadCart, user, lockerPoint } from './storage.js';
  import { createCartRequest, createCartItem, updateCartItem } from './requests.js';
  import Loader from '../components/Loader.svelte';
  import Cart from './Cart.svelte';
  import Form from './Form.svelte';
  import Summary from './Summary.svelte';
  import './styles.scss';

  let { action, url, pid, uid, email } = $props();

  // svelte-ignore state_referenced_locally
  const cartRequired = action.startsWith('add_');
  let loaded = $state(false);

  const urlParams = new URLSearchParams(window.location.search);
  const panacea_data = {
    specialist_id: urlParams.get('specialist_id'),
    specialist_name: urlParams.get('specialist_name'),
    start_datetime: urlParams.get('start_datetime'),
    end_datetime: urlParams.get('end_datetime'),
    appointment_type_id: urlParams.get('appointment_type_id'),
    name: urlParams.get('name'),
    outline: urlParams.get('outline')
  };

  // svelte-ignore state_referenced_locally
  if (uid) $user = { id: uid, email: email };

  const initializeCart = async () => {
    try {
      if (cartRequired) {
        if (!$cart) {
          const response = await createCartRequest();
          $cart = response.data;
        }

        const orderItem = $cart.order_items.find(item => item.product_id == pid);

        if (orderItem?.type == 'Appointment' && panacea_data) {
          await updateCartItem($cart.id, orderItem.id, {token: $cart.token, panacea_data: panacea_data})
        } else {
          await createCartItem($cart, pid, panacea_data);
        }
      }
      await loadCart();
    } catch (error) {
      console.error('Cart initialization failed:', error);
    } finally {
      loaded = true;
    }
  };

  initializeCart();

  // svelte-ignore state_referenced_locally
  if (url && location.pathname !== url) {
    // svelte-ignore state_referenced_locally
    window.history.replaceState('', '', url);
  }

  let notEmpty = $derived($cart?.order_items?.length > 0);

  $effect(() => {
    if ($cart?.no_delivery) $lockerPoint = null;
  });
</script>

<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/svelte-material-ui@8.0.0/bare.min.css" />
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Icons&display=swap">
</svelte:head>

<div class="wrapper">
  {#if loaded}
    {#if $stage === Stages.CART}
      <div class="stage">
        <Cart />
      </div>
    {:else if $stage === Stages.FORM}
      <div class="stage">
        <Form />
      </div>
    {:else if $stage === Stages.SUMMARY}
      <div class="stage">
        <Summary />
      </div>
    {:else if $stage === Stages.PLACED}
      <div class="stage">
        <!-- <PlacedOrder /> -->
      </div>
    {:else}
      404
    {/if}
  {:else}
    <Loader />
  {/if}
</div>

<style>
  .stage {
    display: block;
  }
</style>

